import React, { FC } from "react";
import { withProcedureWraper } from "../..";
import { Box } from "../../../../components/box";
import { Icon } from "../../../../components/icon";
import CreateRequestButton from "../../components/CreateRequestButton";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../AppRoutes";
import { MyRequests, MyApprovals } from "./components";

export const procedureExportWarehouse: FC = withProcedureWraper(() => {
  const history = useHistory();

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
        <div
          className="text-md-left font-weight-normal p-3 bg-info text-white"
          style={{ fontSize: "14px" }}
        >
          <div className="row title__process-container">
            <div className="">
              <span className="icon__title-process">
                <Icon.DocumentWrite />
              </span>
              Đề nghị xuất kho
            </div>
          </div>
        </div>

        <Box
          title="Yêu cầu của tôi"
          titleRight={
            <CreateRequestButton
              onClick={() =>
                history.push(
                  Routes.createExportWarehouse.path.replace(":id", "0")
                )
              }
            />
          }
        >
          <MyRequests />
        </Box>

        <Box title="Các yêu cầu cần duyệt">
          <MyApprovals />
        </Box>
      </div>
    </div>
  );
});
